import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

const Login: React.FC = () => {
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundColor: "#f5f5f5",
        }}>
            <div style={{
                backgroundColor: "white",
                padding: "48px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                textAlign: "center",
                maxWidth: "400px",
                width: "100%",
            }}>
                <h1 style={{
                    color: "#5C5D5E",
                    marginBottom: "8px",
                    fontSize: "24px",
                }}>
                    Amplify Projects & Financials
                </h1>
                <p style={{
                    color: "#666",
                    marginBottom: "32px",
                    fontSize: "14px",
                }}>
                    Sign in with your Amplify Microsoft account
                </p>
                <button
                    onClick={handleLogin}
                    style={{
                        backgroundColor: "#F18E00",
                        color: "white",
                        border: "none",
                        padding: "12px 32px",
                        borderRadius: "4px",
                        fontSize: "16px",
                        cursor: "pointer",
                        width: "100%",
                    }}
                >
                    Sign In
                </button>
            </div>
        </div>
    );
};

export default Login;